import { render, staticRenderFns } from "./infoHeader.vue?vue&type=template&id=1afc6c9e&scoped=true&"
import script from "./infoHeader.vue?vue&type=script&lang=js&"
export * from "./infoHeader.vue?vue&type=script&lang=js&"
import style0 from "./infoHeader.vue?vue&type=style&index=0&id=1afc6c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc6c9e",
  null
  
)

export default component.exports